import React, { ImgHTMLAttributes, ReactElement, useRef } from 'react';
import mitourokuIcon from '../../assets/png/mitouroku_icon.png';

/**
 * Display an image element.
 * It will display the placeholder when could not load the image url.
 * @param props
 */
export const ImageCustom = (
  props: ImgHTMLAttributes<HTMLImageElement>,
): ReactElement => {
  const ref = useRef<HTMLImageElement>(null);

  return (
    <img
      {...props}
      ref={ref}
      src={props.src || mitourokuIcon}
      onError={() => {
        if (ref.current) {
          const element = ref.current;
          element.src = mitourokuIcon;
        }
      }}
    />
  );
};
